import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import reportWebVitals from './reportWebVitals';
import App from './App';
import { ModuleRegistry, provideGlobalGridOptions } from 'ag-grid-community';
import { AllEnterpriseModule, LicenseManager, ServerSideRowModelApiModule } from "ag-grid-enterprise";
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'ag-grid-enterprise/styles/ag-grid.css'; // Core grid CSS
import 'ag-grid-enterprise/styles/ag-theme-alpine.css';
import './styles/global.scss';
import './styles/responsive.scss';
import './styles/fonts.scss';
import './styles/variables.scss';
import { BrowserRouter } from 'react-router-dom';
import { clearState, loadState } from './apis/models/indexdDB';

import ReactGA from "react-ga4";

ModuleRegistry.registerModules([ServerSideRowModelApiModule, AllEnterpriseModule]);
provideGlobalGridOptions({ theme: "legacy" });
LicenseManager.setLicenseKey(
  'Using_this_{AG_Grid}_Enterprise_key_{AG-058917}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{63_moons_technologies_limited}_is_granted_a_{Multiple_Applications}_Developer_License_for_{10}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{Unlimited}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{21_July_2025}____[v3]_[01]_MTc1MzA1MjQwMDAwMA==fcda79af1284cbe0d2b40f226a28105a',
);

// Adds measurement id for Breeze firebase
ReactGA.initialize('G-B8W5FSH18L');

const root = ReactDOM.createRoot(document.getElementById('root'));
//Ameersha N Function runs on app lods or reloads check fo any storage in IndexedDB if a storage for redux is present it will dispathc an action rehydrate the redux store --Start
(async function hydrateAndRender() {
  const EXPIRATION_TIME = 6 * 60 * 60 * 1000; // 24 hours

  async function loadPersistedStateWithExpiry() {
    try {
      const persistedData = await loadState('reduxState');
      if (!persistedData) return null;

      const { state, savedAt } = persistedData;

      if (!savedAt || (Date.now() - savedAt) > EXPIRATION_TIME) {
        // Data expired, clear it
        await clearState('reduxState');
        return null;
      }

      return state;
    } catch (err) {
      console.error('Error loading persisted state', err);
      return null;
    }
  }

  const persisted = await loadPersistedStateWithExpiry();

  if (persisted) {
    store.dispatch({ type: "REHYDRATE", payload: persisted });
  }
//Ameersha N Function runs on app lods or reloads check fo any storage in IndexedDB if a storage for redux is present it will dispathc an action rehydrate the redux store --Start
  root.render(
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  );
})();

reportWebVitals(console.log);

